<template>
  <component
    :is="inputLabel ? 'span' : 'label'"
    class="form-label"
  >
    <span
      v-if="required"
      class="required"
    ><v-icon>mdi-asterisk</v-icon></span>
    {{ labelText }}
    <span
      v-if="filled && (check || ['audio', 'file', 'image', 'scribble', 'signature'].indexOf(fieldType) !== -1)"
      class="filled"
    ><v-icon>mdi-check-circle-outline</v-icon></span>
  </component>
</template>

<script>
export default {
  props: {
    check: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    title: { type: String, default: '' },
    filled: { type: Boolean, default: false },
    fieldType: { type: String, default: '' },
    inputLabel: { type: Boolean, default: false }
  },
  computed: {
    labelText () {
      if (this.title) {
        return this.title;
      } else if (this.check) {
        const fieldTypeName = this.$t('form.elements.' + this.fieldType + '.name');

        if (fieldTypeName) {
          return fieldTypeName;
        }
      }

      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  text-align: left;
  color: rgba(0, 0, 0, 0.6);
  transform-origin: top left;
  font-size: 12px;
  display: block;
}
.required .mdi {
  color: map-get($red, 'base');
  font-size: 12px;
  padding-right: 2px;
}
.filled .mdi {
  color: map-get($green, 'base');
  font-size: 14px;
}
</style>
